export default '/build/a4fd12eb.svg'